import { defaultCtx } from "~/lib/AjaxCtx"
import { buildQueryFilters } from "~/lib/utils"

export default class CalendarService {
    constructor(ctx = defaultCtx) {
        this.$http = ctx
    }

    async getCalendarEvents({ startDate, endDate }) {
        const filterField = buildQueryFilters({
            fromDate: startDate,
            toDate: endDate,
        })
        let url = "/events"
        if (filterField) {
            url = `${url}?filter=${filterField}`
        }
        return await this.$http.fetchData(url)
    }
}
